/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import {
  gatewayImportPnrApi,
  gatewayGetImportPnrSuppliersApi,
} from '../../../api/flightApi';
import { getValueFromAppConfig } from '../../../shared/helper-utils/localStorage';
import './GatewayImportPnr.scss';

const ACTION_OPTIONS = [
  { label: 'ONHOLD', value: 'onhold' },
  { label: 'TRANSACTION', value: 'transaction' },
];
const DOMINT_OPTIONS = [
  { label: 'DOMESTIC', value: 'domestic' },
  { label: 'INTERNATIONAL', value: 'international' },
];

const getSupplierOptions = (response) => {
  const options = [];
  const visited = new Set();
  const visit = (item) => {
    if (!item || typeof item !== 'object' || visited.has(item)) return;
    visited.add(item);
    if (Array.isArray(item)) {
      item.forEach(visit);
      return;
    }

    const supplierId = item.SupplierId;
    if (supplierId !== undefined && supplierId !== null && supplierId !== '') {
      options.push({
        label: `${item.SupplierName}`,
        value: String(supplierId),
      });
      return;
    }
    Object.values(item).forEach(visit);
  };

  visit(response?.Root?.Result);
  return options.filter(
    (option, index) =>
      options.findIndex((candidate) => candidate.value === option.value) ===
      index,
  );
};

function GatewayImportPnrPage() {
  const navigate = useNavigate();
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [form, setForm] = useState({
    // supplierid: '',
    // actionname: '',
    // domint: '',
    gdsname: '',
    gdspnr: '',
    // firstname: '',
    // lastname: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);

  const gdsOptions = useMemo(() => {
    const configuredNames = getValueFromAppConfig('GDS_NAMES');

    if (typeof configuredNames !== 'string') return [];

    return configuredNames
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean)
      .map((name) => ({ label: name, value: name }));
  }, []);

  useEffect(() => {
    const loadSuppliers = async () => {
      setIsLoading(true);
      const response = await gatewayGetImportPnrSuppliersApi();
      const options = getSupplierOptions(response);
      setSupplierOptions(options);
      setIsLoading(false);
      if (!options.length) {
        setAlert({
          variant: 'error',
          title: 'Import PNR',
          description: 'No suppliers are available.',
        });
      }
    };
    loadSuppliers();
  }, []);

  const updateField = (name, value) => {
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const requiredFields = [
      // 'supplierid',
      // 'actionname',
      // 'domint',
      'gdsname',
      'gdspnr',
      // 'firstname',
      // 'lastname',
    ];
    if (requiredFields.some((field) => !String(form[field]).trim())) {
      setAlert({
        variant: 'error',
        title: 'Import PNR',
        description: 'Complete all fields before submitting.',
      });
      return;
    }

    setIsLoading(true);
    const response = await gatewayImportPnrApi(form);
    setIsLoading(false);
    const status = response?.Root?.Status ?? response?.ApiStatus?.Status;
    if (status === 'OK') {
      const transactionId =
        response?.Root?.Result ?? response?.ApiStatus?.Result;
      setAlert({
        variant: 'success',
        title: 'Import PNR',
        description: 'PNR import request submitted successfully.',
      });
      setTimeout(() => {
        navigate(`/flight/ticket/${transactionId}`);
      }, 2000);
    } else {
      setAlert({
        variant: 'error',
        title: 'Import PNR',
        description:
          response?.Root?.Message ??
          response?.ApiStatus?.Message ??
          'Failed to submit the PNR import request.',
      });
    }
  };

  const handleSelect = (option, name) => updateField(name, option?.value ?? '');

  return (
    <main className="gateway-import-pnr-page">
      <div className="gateway-import-pnr-content">
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            description={alert.description}
            onHide={() => setAlert(undefined)}
          />
        )}
        <section className="gateway-import-pnr-card">
          <form onSubmit={handleSubmit}>
            <header className="gateway-import-pnr-header">
              <div>
                <h1>Import PNR</h1>
                <p className="gateway-import-pnr-intro">
                  Fill in all fields to import a PNR.
                </p>
              </div>
            </header>
            <h2 className="gateway-import-pnr-section-heading">
              Booking details
            </h2>
            <div className="gateway-import-pnr-select-grid">
              {/* <div className="gateway-import-pnr-field">
                <AppSelect
                  name="supplierid"
                  label="Supplier ID"
                  placeholder="Select supplier"
                  options={supplierOptions}
                  selectedValue={form.supplierid}
                  onSelect={handleSelect}
                  selectWidth="100%"
                  isClearable={false}
                  required
                />
              </div>
              <div className="gateway-import-pnr-field">
                <AppSelect
                  name="actionname"
                  label="Action"
                  placeholder="Select action"
                  options={ACTION_OPTIONS}
                  selectedValue={form.actionname}
                  onSelect={handleSelect}
                  selectWidth="100%"
                  isClearable={false}
                  required
                />
              </div>
              <div className="gateway-import-pnr-field">
                <AppSelect
                  name="domint"
                  label="Travel Type"
                  placeholder="Select travel type"
                  options={DOMINT_OPTIONS}
                  selectedValue={form.domint}
                  onSelect={handleSelect}
                  selectWidth="100%"
                  isClearable={false}
                  required
                />
              </div> */}
              <div className="gateway-import-pnr-field">
                <AppSelect
                  name="gdsname"
                  label="GDS Name"
                  placeholder="Select GDS"
                  options={gdsOptions}
                  selectedValue={form.gdsname}
                  onSelect={handleSelect}
                  selectWidth="100%"
                  isClearable={false}
                  required
                />
              </div>
              <div className="gateway-import-pnr-field">
                <AppTextInput
                  name="gdspnr"
                  label="PNR"
                  value={form.gdspnr}
                  onChange={(event) =>
                    updateField('gdspnr', event.target.value)
                  }
                  required
                />
              </div>
            </div>
            {/* <div className="gateway-import-pnr-passenger-section">
              <h2 className="gateway-import-pnr-section-heading">
                PNR and passenger details
              </h2>
              <div className="gateway-import-pnr-passenger-grid">
                <div className="gateway-import-pnr-field">
                  <AppTextInput
                    name="gdspnr"
                    label="PNR"
                    value={form.gdspnr}
                    onChange={(event) =>
                      updateField('gdspnr', event.target.value)
                    }
                    required
                  />
                </div>
                <div className="gateway-import-pnr-field">
                  <AppTextInput
                    name="firstname"
                    label="First Name"
                    value={form.firstname}
                    onChange={(event) =>
                      updateField('firstname', event.target.value)
                    }
                    required
                  />
                </div>
                <div className="gateway-import-pnr-field">
                  <AppTextInput
                    name="lastname"
                    label="Last Name"
                    value={form.lastname}
                    onChange={(event) =>
                      updateField('lastname', event.target.value)
                    }
                    required
                  />
                </div>
              </div>
            </div> */}
            <div className="gateway-import-pnr-actions">
              <AppButton
                btnText="Import PNR"
                btnType="submit"
                onClick={handleSubmit}
              />
            </div>
          </form>
        </section>
      </div>
    </main>
  );
}

export default GatewayImportPnrPage;
